import * as React from 'react';
import * as ReactDOM from 'react-dom';

import {
    WrapperModal,
    WrapperCloseIcon,
    WrapperHeaderSection,
    WrapperModalBody,
    WrapperAlert,
    AlertMessage
} from './styled';
import { Icon } from '@app/src/common/Icon';
import * as PropTypes from 'prop-types';
import { COLORS } from '@app/src/ui';

let modalContainer;

const isClientEnv = () => {
  return typeof window !== 'undefined' && typeof document !== 'undefined';
}

const isClient = isClientEnv();

if (isClient) {
    modalContainer = document.createElement('div');
    modalContainer.id = 'container-modal';
    document.body.appendChild( modalContainer );
}

const ESCAPE_KEY = 27;
const OUTSIDE_MODAL_ID = 'parent-control-flag';

interface Props {
    show?: boolean;
    closeModal?: Function;
    customBody?: boolean;
    afterClose?: Function;
    alert?: string;
    className?: string;
    borderRadius?: string;
}

export class Modal extends React.Component<Props, {}> {

    static propTypes = {
        show: PropTypes.bool,
        closeModal: PropTypes.func,
        customBody: PropTypes.bool,
        alert: PropTypes.string,
        className: PropTypes.string
    }

    static defaultProps = {
        show: false,
        customBody: false
    }

    public element: Element;

    constructor (props: Props) {
        super(props);
        this.element = isClient ? document.createElement('div') : null;
    }

    componentDidMount() {
        if(isClient) {
            if(this.props.show) {
                window.addEventListener('keyup', this.KeyUpAllAppHandler, false);
            }
        }
    }

    componentDidUpdate() {
        if(isClient) {
            if(this.props.show) {
                window.addEventListener('keyup', this.KeyUpAllAppHandler, false);
            } else {
                window.removeEventListener('keyup', this.KeyUpAllAppHandler, false);
            }
        }
    }

    componentWillUnmount() {
        if(isClient) {
            window.removeEventListener('keyup', this.KeyUpAllAppHandler, false);
        }
    }
    clickOutSideModalHandler = (event: any) => {
        if (event.target.id === OUTSIDE_MODAL_ID) {
            typeof this.props.closeModal === 'function' && this.props.closeModal();
            typeof this.props.afterClose === 'function' && this.props.afterClose();
        }
    }

    KeyUpAllAppHandler = (event: any) => {
        if (event.keyCode === ESCAPE_KEY) {
            typeof this.props.closeModal === 'function' && this.props.closeModal();
            typeof this.props.afterClose === 'function' && this.props.afterClose();
        }
    }

    closeModalFromDefaultHandler = () => {
        typeof this.props.closeModal === 'function' && this.props.closeModal();
        typeof this.props.afterClose === 'function' && this.props.afterClose();
    }

    render () {
        let body = this.props.customBody ? (
            this.props.children
        ):
        (
            <WrapperModalBody borderRadius={this.props.borderRadius}>
                <WrapperHeaderSection>
                    <WrapperCloseIcon onClick={this.closeModalFromDefaultHandler}>
                        <Icon data-name='icon-close-bold' fill={COLORS.GRAY_DARK} width='13' height='13' />
                    </WrapperCloseIcon>
                </WrapperHeaderSection>
                { this.props.alert ? (
                    <WrapperAlert>
                        <AlertMessage>{this.props.alert}</AlertMessage>
                    </WrapperAlert>
                    ):  this.props.children }
            </WrapperModalBody>
        );

        let modal = this.props.show && (
            <WrapperModal id={OUTSIDE_MODAL_ID} onClick={this.clickOutSideModalHandler}>
                {body}
            </WrapperModal>
        );
        return isClient ? ReactDOM.createPortal( modal, modalContainer) : null;
    }
}
